import { combineReducers } from 'redux';
import settingAccountReducer from './account';
import bankAccountReducer from './bankAccount';
import settingCheckoutReducer from './checkout';
import settingReceiptReducer from './receipt';
import emailNotificationReducer from './emailNotification';
import settingBillingReducer from './billing';
import paymentMethodReducer from './paymentMethod';

export default combineReducers({
  account: settingAccountReducer,
  bankAccount: bankAccountReducer,
  checkout: settingCheckoutReducer,
  receipt: settingReceiptReducer,
  emailNotification: emailNotificationReducer,
  billing: settingBillingReducer,
  paymentMethod: paymentMethodReducer,
});
